<template>
  <div class="animate__animated animate__fadeIn">
    <top-bar :shadow="true">
      <div class="top-box">
        <img :src="logoImg" class="logo" />
        <div class="menus-box" :style="fontColor">
          <div
            class="menus"
            v-for="(m, mi) in menus"
            :style="active == m.path ? { fontWeight: 600 } : ''"
            :key="mi"
            @mouseover="changeOver(m)"
            :class="m.hover ? 'hover-bg' : ''"
            @mouseleave="mouseLeave(m)"
            @click="changePath(m)"
          >
            {{ m.name }}
            <div class="dt-line" v-if="active == m.path" :style="dtBg"></div>
            <div class="se-me hover-bg" v-if="m.hover">
              <div
                class="child"
                :style="fontColor"
                v-for="(c, ci) in m.child"
                :key="ci"
                @click.stop="changePath(c)"
              >
                {{ c.name }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </top-bar>
    <div class="header-tag">
      <span>最新动态</span>
      <!-- <span style="color: #666;"> - 环保工作场所</span> -->
    </div>
    <div class="body-box">
      <div class="left-box">
        <div class="tag-title">新闻推荐</div>
        <!-- 新闻1-->
        <div class="new-box new-border" v-if="type == 1">
          <a href="DynamicInfo?type=8" style="font-size: 16px;color: #333;">清捕零碳CCUS固碳混凝土技术 入选《 Impact 50 可持续创新先锋案例》</a>
        </div>
        <div class="new-box new-border" v-if="type == 1">
          <a href="DynamicInfo?type=7" style="font-size: 16px;color: #333;">清捕零碳与中建香港签署合作协议 固碳混凝土建材加速湾区建筑低碳发展</a>
        </div>
        <div class="new-box new-border" v-if="type == 1">
          <a href="DynamicInfo?type=6" style="font-size: 16px;color: #333;">清捕零碳公司运用CCUS技术 获国内首张固碳混凝土建材碳足迹认证证书</a>
        </div>
        <!-- 新闻1-->     
		    <div class="new-box new-border" v-if="type == 2">
          <a href="DynamicInfo?type=8" style="font-size: 16px;color: #333;">清捕零碳CCUS固碳混凝土技术 入选《 Impact 50 可持续创新先锋案例》</a>
        </div>
        <div class="new-box new-border" v-if="type == 2">
          <a href="DynamicInfo?type=7" style="font-size: 16px;color: #333;">清捕零碳与中建香港签署合作协议 固碳混凝土建材加速湾区建筑低碳发展</a>
        </div>
        <div class="new-box new-border" v-if="type == 2">
          <a href="DynamicInfo?type=6" style="font-size: 16px;color: #333;">清捕零碳公司运用CCUS技术 获国内首张固碳混凝土建材碳足迹认证证书</a>
        </div>
		    <div class="new-box new-border" v-if="type == 3">
          <a href="DynamicInfo?type=8" style="font-size: 16px;color: #333;">清捕零碳CCUS固碳混凝土技术 入选《 Impact 50 可持续创新先锋案例》</a>
        </div>
        <div class="new-box new-border" v-if="type == 3">
          <a href="DynamicInfo?type=7" style="font-size: 16px;color: #333;">清捕零碳与中建香港签署合作协议 固碳混凝土建材加速湾区建筑低碳发展</a>
        </div>
        <div class="new-box new-border" v-if="type == 3">
          <a href="DynamicInfo?type=6" style="font-size: 16px;color: #333;">清捕零碳公司运用CCUS技术 获国内首张固碳混凝土建材碳足迹认证证书</a>
        </div>
		    <div class="new-box new-border" v-if="type == 4">
          <a href="DynamicInfo?type=8" style="font-size: 16px;color: #333;">清捕零碳CCUS固碳混凝土技术 入选《 Impact 50 可持续创新先锋案例》</a>
        </div>
        <div class="new-box new-border" v-if="type == 4">
          <a href="DynamicInfo?type=7" style="font-size: 16px;color: #333;">清捕零碳与中建香港签署合作协议 固碳混凝土建材加速湾区建筑低碳发展</a>
        </div>
        <div class="new-box new-border" v-if="type == 4">
          <a href="DynamicInfo?type=6" style="font-size: 16px;color: #333;">清捕零碳公司运用CCUS技术 获国内首张固碳混凝土建材碳足迹认证证书</a>
        </div>
        <div class="new-box new-border" v-if="type == 5">
          <a href="DynamicInfo?type=8" style="font-size: 16px;color: #333;">清捕零碳CCUS固碳混凝土技术 入选《 Impact 50 可持续创新先锋案例》</a>
        </div>
        <div class="new-box new-border" v-if="type == 5">
          <a href="DynamicInfo?type=7" style="font-size: 16px;color: #333;">清捕零碳与中建香港签署合作协议 固碳混凝土建材加速湾区建筑低碳发展</a>
        </div>
        <div class="new-box new-border" v-if="type == 5">
          <a href="DynamicInfo?type=6" style="font-size: 16px;color: #333;">清捕零碳公司运用CCUS技术 获国内首张固碳混凝土建材碳足迹认证证书</a>
        </div>
		    <div class="new-box new-border" v-if="type == 6">
          <a href="DynamicInfo?type=8" style="font-size: 16px;color: #333;">清捕零碳CCUS固碳混凝土技术 入选《 Impact 50 可持续创新先锋案例》</a>
        </div>
        <div class="new-box new-border" v-if="type == 6">
          <a href="DynamicInfo?type=7" style="font-size: 16px;color: #333;">清捕零碳与中建香港签署合作协议 固碳混凝土建材加速湾区建筑低碳发展</a>
        </div>
        <div class="new-box new-border" v-if="type == 6">
          <a href="DynamicInfo?type=10" style="font-size: 16px;color: #333;">利用二氧化碳生产混凝土，「清捕零碳」完成千万元天使+轮融资</a>
        </div>
        <div class="new-box new-border" v-if="type == 7">
          <a href="DynamicInfo?type=8" style="font-size: 16px;color: #333;">清捕零碳CCUS固碳混凝土技术 入选《 Impact 50 可持续创新先锋案例》</a>
        </div>
        <div class="new-box new-border" v-if="type == 7">
          <a href="DynamicInfo?type=6" style="font-size: 16px;color: #333;">清捕零碳公司运用CCUS技术 获国内首张固碳混凝土建材碳足迹认证证书</a>
        </div>
        <div class="new-box new-border" v-if="type == 7">
          <a href="DynamicInfo?type=10" style="font-size: 16px;color: #333;">利用二氧化碳生产混凝土，「清捕零碳」完成千万元天使+轮融资</a>
        </div>
        <div class="new-box new-border" v-if="type == 8">
          <a href="DynamicInfo?type=7" style="font-size: 16px;color: #333;">清捕零碳与中建香港签署合作协议 固碳混凝土建材加速湾区建筑低碳发展</a>
        </div>
        <div class="new-box new-border" v-if="type == 8">
          <a href="DynamicInfo?type=6" style="font-size: 16px;color: #333;">清捕零碳公司运用CCUS技术 获国内首张固碳混凝土建材碳足迹认证证书</a>
        </div>
        <div class="new-box new-border" v-if="type == 8">
          <a href="DynamicInfo?type=10" style="font-size: 16px;color: #333;">利用二氧化碳生产混凝土，「清捕零碳」完成千万元天使+轮融资</a>
        </div>
         <div class="new-box new-border" v-if="type == 9">
          <a href="DynamicInfo?type=7" style="font-size: 16px;color: #333;">清捕零碳与中建香港签署合作协议 固碳混凝土建材加速湾区建筑低碳发展</a>
        </div>
        <div class="new-box new-border" v-if="type == 9">
          <a href="DynamicInfo?type=6" style="font-size: 16px;color: #333;">清捕零碳公司运用CCUS技术 获国内首张固碳混凝土建材碳足迹认证证书</a>
        </div>
        <div class="new-box new-border" v-if="type == 9">
          <a href="DynamicInfo?type=10" style="font-size: 16px;color: #333;">利用二氧化碳生产混凝土，「清捕零碳」完成千万元天使+轮融资</a>
        </div>
        <div class="new-box new-border" v-if="type == 10">
          <a href="DynamicInfo?type=7" style="font-size: 16px;color: #333;">清捕零碳与中建香港签署合作协议 固碳混凝土建材加速湾区建筑低碳发展</a>
        </div>
        <div class="new-box new-border" v-if="type == 10">
          <a href="DynamicInfo?type=6" style="font-size: 16px;color: #333;">清捕零碳公司运用CCUS技术 获国内首张固碳混凝土建材碳足迹认证证书</a>
        </div>
        <div class="new-box new-border" v-if="type == 10">
          <a href="DynamicInfo?type=9" style="font-size: 16px;color: #333;">清捕零碳与恒隆签订战略合作 推动建筑行业减少隐含碳排放</a>
        </div>	
        <div class="dot"></div>
      </div>
      <div class="right-box">
        <div class="ri-title" v-if="type == 1">
          清洁捕获研发能"吃"CO₂的混凝土,让98%废弃CO₂被有效利用
        </div>
        <div class="ri-title" v-if="type == 2">
          浙大教授王涛:自主研发抢跑CCUS科技创新让CO₂变废为宝
        </div>
        <div class="ri-title" v-if="type == 3">
          国际气候峰会｜清洁捕获分享CO₂制造低碳混凝土前沿技术
        </div>
        <div class="ri-title" v-if="type == 4">
          清洁捕获入驻国家电投清洁能源融通创新发展平台
        </div>
		    <div class="ri-title" v-if="type == 5">
          「清洁捕获」完成数百万天使轮融资，想把二氧化碳封存在混凝土里
        </div>
        <div class="ri-title" v-if="type == 6">
          清捕零碳公司运用CCUS技术 获国内首张固碳混凝土建材碳足迹认证证书
        </div>
        <div class="ri-title" v-if="type == 7">
          清捕零碳与中建香港签署合作协议 固碳混凝土建材加速湾区建筑低碳发展
        </div>
        <div class="ri-title" v-if="type == 8">
          清捕零碳CCUS固碳混凝土技术 入选《 Impact 50 可持续创新先锋案例》
        </div>
        <div class="ri-title" v-if="type == 9">
          清捕零碳与恒隆签订战略合作 推动建筑行业减少隐含碳排放
        </div>
        <div class="ri-title" v-if="type == 10">
          利用二氧化碳生产混凝土，「清捕零碳」完成千万元天使+轮融资
        </div>
        <div class="content" v-if="type == 1">
          <p style="text-indent: 20px">
            当人们在谈绿色建筑的时候，往往最关注哪些环节 ?
            是节能的环保设计理念？还是绿色的清洁能源？
          </p>
          <img src="../static/news/n1.png" class="msg-img" />
          <p style="text-indent: 20px">
            作为用途最广泛的人造建材，混凝土是现代社会大部分建筑的基底。然而，混凝土不仅事关人们生活的功能性和审美，它的生产也与自然环境有着千丝万缕的关联。
          </p>
          <img src="../static/news/n2.png" class="msg-img" />
          <p style="text-indent: 20px">
            近日，SDGs创业挑战赛举办了第四期“赋能后浪与零碳社区”论坛。作为一家专注利用人工技术清除CO₂的创新企业，清洁捕获联合创始人赵超受邀参与此次论坛的分享。据赵超介绍清洁捕获公司通过对碳捕捉、利用与封存（CCUS）技术的研发，已成功将捕集的CO₂封存在混凝土材料中，生产出减少80%碳足迹的低碳混凝土产品。现场，与会嘉宾们还共同探讨了低碳混凝土在建筑行业能够广泛应用的前景及发展规划。
          </p>
          <img src="../static/news/n3.png" class="msg-img" />
          <p style="text-indent: 20px">
            当前，全球经济高速发展，建筑行业占全球GDP的13%，其中混凝土作为基础设施、房屋、洁净饮水和实现社会抗灾能力的关键原材料，需求量巨大。目前，全球混凝土行业的市场规模已达到了1万亿美元，仅中国混凝土行业每年的市场需求量就近30亿立方米
            ，生产规模超过万亿元。巨大的需求量同时意味高排放，水泥是混凝土中必不可少的“粘黏剂”，它与水发生反应，使碎石、砂砾和沙土结合。但水泥在生产加工过程中消耗了大量石灰石、黏土和电力能源。相当于每生产一吨水泥，就会向大气中释放约一吨的CO₂，这使得水泥、混凝土行业占全球碳排放总量的5-7%。
          </p>
          <p style="text-indent: 20px">
            如何在中国“双碳”目标的大背景下，有效帮助建筑、基建这些混凝土使用大户行业降低碳排放、为混凝土生产企业提供绿色转型的机会，长期专注碳捕捉、利用与封存（CCUS）技术的研发与商业化的清洁捕获公司，为行业提供了一个低成本的除碳技术解决方案。
          </p>
          <p style="text-indent: 20px">
            据介绍，清洁捕获在全国首创的低碳混凝土原料改良技术、低碳混凝土矿化利用技术，将从能源企业捕集的CO₂用于制造低碳混凝土绿色建材，实现CO₂的高效封存利用。目前该技术在帮助混凝土工厂降低成本、提升混凝土建材质量的同时，可达到生产的混凝土预制件产品比现有产品减少全生命周期约80%碳排放，有效促进绿色建材行业发展。
          </p>
          <img src="../static/news/n4.png" class="msg-img" />
          <p style="text-indent: 20px">
            值得一提的是，清洁捕获首创的低碳混凝土原料改良技术，通过研究混凝土中加入CO₂后微观反应机理，形成了多元固废掺杂配方体系，原材料中水泥用量仅占比10%，90%的固体原材料则来自当地的工业固废，包括钢渣和粉煤灰等。同时该技术能能对不同地域的固废比例定制不同掺杂配方，以达到利用率、产品效果最佳。目前经过测试，新型的混凝土产品相比传统养护工艺产品在力学强度、抗冻融性、重金属析出等方面优势明显。
          </p>
          <img src="../static/news/n5.png" class="msg-img" />
          <p style="text-indent: 20px">
            而低碳混凝土矿化利用技术，则是通过开发一套CCUS-CO₂养护一体化体系标准化设备，利用捕获工业排放的CO₂应用于生产混凝土的养护环节，整个体系实现了CO₂闭环利用，目前的CO₂转化率在98%左右，几乎没有二次排放。
          </p>
          <img src="../static/news/n6.png" class="msg-img" />
          <p style="text-indent: 20px">
            近期，在国家重点研发计划课题支持下，清洁捕获参与的国际上首个万吨级CO₂
            矿化养护混凝土示范工程已成功落地。在河南焦作开展的该示范工程通过CO₂
            矿化养护技术实现每年1 万吨的CO₂ 封存，并生产1 亿块MU15
            标准的轻质实心混凝土砖。
          </p>
          <p style="text-indent: 20px">
            目前清洁捕获公司已开始依托成熟的技术与多家高碳排放的能源企业、混凝土生产商、建筑企业开展合作。
          </p>
          <img src="../static/news/n7.png" class="msg-img" />
          <p style="text-indent: 20px">
            赵超在论坛上表示，“CO₂的矿化反应在低于600摄氏度以下基本不可逆， 此项技术可以实现CO₂长期、模化、稳定封存，未来有非常广阔的固碳潜力，预计到2024年，我们每年可以通过生产低碳混凝土的方式，有效封存CO₂达到250万吨。“
          </p>
        </div>
        <div class="content" v-if="type == 2">
          <p style="text-indent: 20px">内容转载：科技日报</p>
          <p style="text-indent: 20px">
            7月16日，全国碳排放权交易市场开市交易，此后6日累计成交量达483.3万吨，成交额近2.5亿元。根据生态环境部测算，全国碳交易市场首批纳入的企业的碳排放量超过40亿吨二氧化碳。2011年10月，国家发改委发布《关于开展碳排放交易试点工作的通知》，批准了北京、天津、上海等7个省市开展碳排放权交易试点。我国碳市场由此开始建设，释放出“绿色低碳即竞争力”这一信号。浙江大学能源工程学院王涛教授认为，在体量上，碳排放可谓人类历史上碰到的最大的废弃物处理问题。“通过技术和管理手段的创新，大气中的废碳，也能像垃圾一样得到消纳，甚至变废为宝，实现环境保护。”他说。
          </p>
          <div class="book-title-small">明晰攻坚线路，下好创新先手棋</div>
          <p style="text-indent: 20px">
            数据显示，2019年，福建省碳排放2.4亿吨，安徽省3.1亿吨，初步考虑碳达峰年分别为2029年与2028年。同年，浙江省碳排放总量为4.16亿吨，主要来自能源领域，占比高达67.3%。“2020年浙江省能耗强度约为0.41吨标煤/万元，碳排放强度约为0.76吨二氧化碳/万元，与发达经济体和先进省份相比总体偏高。”浙江省科技厅社发处副处长金宏伟坦言，浙江省的目标是“确保2029年达峰、力争2027年达峰”，目前来看，存在一定压力。“十三五”以来，浙江省在大气污染防治、节能减排等领域，通过省级重点研发计划共计支持项目183项，累计投入财政科研经费5.37亿元，引导社会资金研发投入近30亿元，在碳基能源清洁利用等方面具有良好的科技创新基础。
            今年6月，浙江在全国率先出台《浙江省碳达峰碳中和科技创新行动方案》（以下简称《行动方案》），提出到2025年，初步构建全省绿色低碳技术创新体系，大幅提升全省绿色低碳前沿技术原始创新能力，显著提高减污降碳关键核心技术攻关能力，抢占碳达峰、碳中和技术制高点。记者了解到，《行动方案》聚焦可再生能源、储能、氢能、二氧化碳捕集利用与封存（CCUS）、生态碳汇等五大核心技术领域进行发力，力争到2025年取得重大科技成果10项以上。根据《行动方案》，浙江还将围绕能源供给转型和脱碳降碳需求，重点突破火电机组提效降碳，太阳能、风力、生物质与海洋能发电，规模化储能，先进输配电等关键技术，支持“风光倍增”工程和“千万光伏”计划实施。金宏伟表示，“十四五”是碳达峰的关键期、窗口期，浙江准备用好科技创新这一关键变量。
          </p>
          <div class="book-title-small">打通基层壁垒，县域尝试“碳普惠”</div>
          <p style="text-indent: 20px">
            放眼国际，发电行业因煤炭消费多、二氧化碳排放大且管理制度相对健全等原因，是各国碳市场优先选择纳入的行业。本次全国碳排放权交易市场上线，同样采取循序渐进的方式，首批纳入2000多家电力行业的重点控排企业，约占全国碳排放总量的40%。然而，光伏发电行业可凭借零碳排放，在碳交易中可成为卖方。以浙江省为例，地方发展光伏产业的自然资源条件虽并非最佳，但相关技术转化率在国内位居前列。截至2020年底，浙江光伏发电装机容量1517万千瓦，光伏发电已成为浙江仅次于火力发电的第二大电力来源。在浙江省温州市乐清市，当地分布式光伏单体项目有6520个，合计装机容量约29.4万千瓦，占温州光伏发电装机容量总量的近六成，年发电量约1亿千瓦时。今年7月以来，当地凭借区位优势，启动建设乐清市碳市场，目标是建成浙江省首个地方“碳普惠”市场。该市场建设单位之一、国网乐清市供电公司相关负责人介绍，普通居民楼安装的光伏设备，只要通过发电量上网实现减排，设备用户就可以作为卖家进入地方碳市场，有机会通过碳交易获取额外收益。而有减排需求的企业，可根据自身情况，随时购买所需碳量。“相比于全国碳交易市场，乐清市‘碳普惠’市场有着交易门槛低的优势，允许企业和个人自主参与碳交易。”该负责人介绍，“碳普惠”是由政府推行，为市民和小微企业的节能减碳行为赋予价值而建立的激励机制，通过将低碳行为量化为减碳量，使市民和小微企业可以换取商业优惠，经核证后的减碳量还可通过碳排放权交易变现。据了解，乐清市“碳普惠”市场建成后，将争取2022年融入长三角地区“碳普惠”体系，加快推动江浙沪皖四地间的跨省自主碳交易，激励乐清地区自愿减排项目开发。
          </p>
          <div class="book-title-small">废气捕集利用，技术从储备转向应用</div>
          <p style="text-indent: 20px">
            “开展碳交易后，碳排放会成为生产要素，被计入企业生产成本。这一改变更深层次的内涵在于激励企业改进生产技术、研发使用低碳零碳技术。”金宏伟说。
          </p>
          <img src="../static/news/nn1.png" class="msg-img" />
          <img src="../static/news/nn2.png" class="msg-img" />
          <p style="text-indent: 20px">
            通过大规模捕集燃煤电厂烟气中的二氧化碳，可连续生产纯度99.5%的工业级合格液态二氧化碳产品……6月25日，位于陕西省榆林市，每年15万吨碳捕集与封存示范项目在陕西国华锦界能源有限责任公司一次通过168小时试运行。“这一由浙江大学牵头承担的国家重点研发计划项目，在技术层面确保了100%国产。”作为项目的技术骨干，王涛介绍，团队有20年的碳捕集技术积累，随着我国“双碳”目标的提出，以往作为储备的技术，正加快转向应用。
          </p>
          <p style="text-indent: 20px">
            走进浙江大学热能工程研究所，王涛向记者展示了团队运用CCUS技术制备的混凝土砖样品。“去年8月，我们促成全球首个工业规模二氧化碳养护混凝土示范工程落地河南，可实现每年1万吨的二氧化碳温室气体封存，并生产1亿块轻质实心混凝土砖。”中国石油大学（北京）彭勃教授认为，CCUS技术的规模化部署，在实现二氧化碳减排效益的同时，还将为能源结构的调整和绿色低碳转型提供缓冲时间。根据《行动方案》，浙江尝试突破烟气二氧化碳捕集、二氧化碳矿化及微藻利用技术，部署直接空气二氧化碳捕集等负排放技术，并积极推动火电机组十万吨级二氧化碳捕集与利用技术应用示范，力争到2025年，实现二氧化碳捕集率、转化利用率均大于90%，碳捕集能耗下降35%以上。
          </p>
          <p style="text-indent: 20px">
            “CCUS技术等减碳技术的转化应用，目前受到二氧化碳处理量大、应用成本过高的制约，但不妨结合处理效率来看待。”王涛分析道，以一座百万千瓦级燃煤电厂为例，完成脱硫脱硝技术处理，投资费用约为1亿元，完成碳捕集利用可能要20亿元。“但二氧化硫和二氧化碳在烟气中的浓度相差数百倍，按单位质量污染物的处理成本来算，孰高孰低，还难以评判。CCUS技术应用成本还可通过技术迭代进行压缩。比如我们团队在榆林市的示范项目，最初试验的捕集成本为400元/吨，如今降至260元/吨。”王涛表示，相关减碳负碳技术的转化应用，需要有条件的国企、央企、龙头企业承担起社会责任。走进浙江大学热能工程研究所，王涛向记者展示了团队运用CCUS技术制备的混凝土砖样品。“去年8月，我们促成全球首个工业规模二氧化碳养护混凝土示范工程落地河南，可实现每年1万吨的二氧化碳温室气体封存，并生产1亿块轻质实心混凝土砖。”中国石油大学（北京）彭勃教授认为，CCUS技术的规模化部署，在实现二氧化碳减排效益的同时，还将为能源结构的调整和绿色低碳转型提供缓冲时间。根据《行动方案》，浙江尝试突破烟气二氧化碳捕集、二氧化碳矿化及微藻利用技术，部署直接空气二氧化碳捕集等负排放技术，并积极推动火电机组十万吨级二氧化碳捕集与利用技术应用示范，力争到2025年，实现二氧化碳捕集率、转化利用率均大于90%，碳捕集能耗下降35%以上。
          </p>
        </div>
        <div class="content" v-if="type == 3">
          <p style="text-indent: 20px">
            2020年9月22日，中国在第七十五届联合国大会上提出，在2030年实现碳达峰、2060年实现碳中和的“双碳”目标。
          </p>
          <p style="text-indent: 20px">
            为积极推动国家碳中和愿景和全球控温目标实现，凤凰卫视与世界自然基金会（WWF）于2021年9月22日-24日主办2021零碳使命国际气候峰会，主题为“全球碳中和与中国担当”。联合主办本次峰会的有凤凰网、凤凰都市传媒、北京市企业家环保基金会（SEE基金会）、大道应对气候变化促进中心（C
            Team）、公众环境研究中心（IPE），英国以COP26联合国气候大会主席国身份参与。
          </p>
          <img src="../static/news/p3/p31.png" class="msg-img" />
          <p style="text-indent: 20px">
            美国前副总统阿尔·戈尔、联合国驻华协调员常启徳、联合国环境规划署代表处代表涂瑞和、生态环境部宣传教育中心主任贾峰、世界自然基金会全球总干事马可·兰博蒂尼等七十多位嘉宾参与峰会，就全球碳中和、企业气候雄心、绿色金融、能源转型、绿色建筑以及低碳交通等话题进行分享和讨论，旨在集聚各方资源，充分调动企业参与应对气候变化的积极性，为地方政府、企业在实现碳达峰、碳中和的目标过程中，提供战略规划、技术应用、成果展示、知识分享及国际交流等多样化的指导和服务。
          </p>
          <img src="../static/news/p3/p32.png" class="msg-img" />
          <p style="text-indent: 20px">
            在本次峰会活动中，清洁捕获联合创始人赵超受邀参加国际气候峰会“C
            位青年 x 凤凰卫视世纪大讲堂
            ”。赵超在活动现场分享了由清洁捕获团队研发的将二氧化碳封存到混凝土建材中的新技术。该技术不仅能提高了混凝土的性能，更可实现将二氧化碳高效封存利用的效果。未来，这项技术将会继续落实和发展，为实现碳中和提供可靠的途径。
          </p>
          <div class="book-title-small">以下为赵超在“C位青年说”中发言实录</div>
          <p style="text-indent: 20px">
            凤凰卫视主持人田川：接下来我们要请到的这位青年是清洁捕获联合创始人赵超，他要演讲的题目是《捕集二氧化碳制造低碳混凝土》。低碳的混凝土到底有什么样的优势，会为我们的生活带来怎么样的改变？下面交给您，谢谢。
          </p>
          <img src="../static/news/p3/p33.png" class="msg-img" />
          <p style="text-indent: 20px">
            赵超：大家好，我是清洁捕获的赵超。首先简单介绍一下我们的团队，我们团队专注开发CCUS碳捕集和转化利用技术，希望利用我们的技术，去实现人工大规模的捕集并封存利用废弃二氧化碳，以此来恢复地球的碳平衡。
          </p>
          <p style="text-indent: 20px">
            在介绍我们研究的主要方向之前，先帮助大家了解一下背景，我们为什么急需打造低碳的混凝土建材产品？首先介绍几个数据，会帮助大家更好的了解。
          </p>
          <p style="text-indent: 20px">
            大家觉得水泥和混凝土跟我们有什么关系？其实这种材料跟大家日常生活都是息息相关的，像我们走的道路、开车要通过的高架桥、要住的房屋，其实都是用到了混凝土建材。
          </p>
          <img src="../static/news/p3/p34.png" class="msg-img" />
          <p style="text-indent: 20px">
            混凝土是人类有史以来使用量最大的建筑材料之一，它每年的消耗量目前是170亿吨。水泥是混凝土中最重要的原料之一，单独看水泥生产过程中的碳排放量就已经占了全球碳排放的7%，是工业排放中非常主要的一个排放源。而中国因为在快速发展过程中有大量的基础设施建设投入，致使水泥用量占到全球所有国家用量的总和，占到全球的60%以上。同样，由于中国水泥、混凝土使用量巨大，也随之拥有一个1.7万亿的巨大市场。
          </p>
          <p style="text-indent: 20px">
            以上数据足以证明建材行业的碳减排是一个非常大的挑战，但在我们看来也是一个非常大的机遇。
          </p>
          <p style="text-indent: 20px">
            首先每个行业要去实现碳中和，从逻辑上来说有不同路径，大家比较容易想到的就是减少向大气排放二氧化碳，这方面的技术有很多，包括新能源汽车、新能源材料的开发，以及各行业减少能耗等不同的方式。那么如何去吸收大气中已经存在的二氧化碳呢？有两个路径，其一是通过自然的解决方案，比如森林碳汇。而另一方面就是我们今天重点谈到的，以及我们团队重点研究的方向，利用人工科学的技术来大规模捕集二氧化碳并将其有效的利用。
          </p>
          <img src="../static/news/p3/p35.png" class="msg-img" />
          <p style="text-indent: 20px">
            接下来我来介绍我们是如何捕集空气中的二氧化碳，并制造出低碳混凝土建材的工艺流程。首先我们会从高排放企业捕集二氧化碳，提纯之后用槽罐车或者是管道运送到混凝土工厂。与此同时，我们在混凝土工厂用压砖机去制备好我们需要制造成形的混凝土预制建材。随后我们在混凝土工厂当中将捕集到的二氧化碳加入到反应釜中，在反应釜里面我们用二氧化碳替代原先高温的蒸汽，矿化养护混凝土建材。新研发的生产工艺过程，能够做到98%二氧化碳被有效利用。
          </p>
          <img src="../static/news/p3/p36.png" class="msg-img" />
          <p style="text-indent: 20px">
            通过这样的技术手段生产出新型低碳混凝土材料，不但让混凝土建材的强度等指标有明显提升，养护时间也比之前降低了一半以上，大大降低了生产混凝土的成本。经过测算，它全生命周期的碳排放相较于原有的制作工艺能够减少碳排放80%，未来我们甚至有机会做到碳中和的混凝土建材。
          </p>
          <img src="../static/news/p3/p37.png" class="msg-img" />
          <p style="text-indent: 20px">
            相较于传统的制作工艺，我们制作过程中还加入了大量的固废资源，可以消耗大量的粉煤灰、干砂等固废，多层面推动混凝土建材的绿色发展。
          </p>
          <img src="../static/news/p3/p38.png" class="msg-img" />
          <p style="text-indent: 20px">
            目前，该项新技术已开始在中国的市场中进行推广、应用。我们也希望在商业的模式中能够让上下游利益相关方都能够从中获利，以达到模式的可持续性发展。通过现阶段的实践来看，基本可以实现几方共赢发展的效果。
          </p>
          <p style="text-indent: 20px">
            例如高排放企业，他们应用我们的技术可以去解决大规模排放的二氧化碳在捕集后有效封存利用的问题。对于混凝土工厂来说，应用我们的技术可以在日渐增长的绿色建材市场上获得先发的优势，甚至可以获得更多的利润。对于建筑企业以及基建企业而言，采购低碳混凝土建材在不增加其成本的前提下，能够在采购端实现大规模的减排目标。
          </p>
          <img src="../static/news/p3/p39.png" class="msg-img" />
          <p style="text-indent: 20px">
            森林植被每年能够吸收11亿吨的二氧化碳，是一个非常巨大的固碳渠道。我们的愿景就是未来能够把混凝土建材开发成同样巨大的固碳资源，让大家在有朝一日脚踩的道路、住的建筑，都可以成为封存利用二氧化碳的一个重要渠道。这样的话每一个人都间接会成为解决气候变化的参与者。
          </p>
          <p style="text-indent: 20px">
            以上就我今天的分享，期望未来我们的技术能够跟大家一同去对抗气候变化，共同实现碳中和的目标。
          </p>
        </div>
        <div class="content" v-if="type == 4">
          <p style="text-indent: 20px">
            
          </p>
          <img src="../static/news/p4/p41.png" class="msg-img" />
          <p style="text-indent: 20px">
            2021年9月28日上午，清洁捕获正式入驻在国家电投清洁能源融通创新发展平台，清洁捕获联合创始人赵超作为入驻企业代表参加了在北京昌平未来科学城国家电投集团中央研究院园区举办的平台揭牌仪式。
          </p>
          <p style="text-indent: 20px">
            在入驻会议上，清洁捕获与国家电投清洁能源融通创新发展平台签署入驻协议。未来双方将在二氧化碳捕集、利用等方面，开展联合攻关、联合研发、成果转化的落地等相关工作，共同助力国家清洁能源事业发展，促进科技创新、推动产业发展。
          </p>
          <img src="../static/news/p4/p42.png" class="msg-img" />
          <p style="text-indent: 20px">
            9月28日，“国家电投清洁能源融通创新发展平台启动会暨大中小企业携手共进开新局科技沙龙”在昌平未来科学城国家电投中央研究院园区举行。北京市科学技术委员会、中关村科技园区管委会，北京市未来科学城管委会，北京未来科学城发展集团等相关负责人，中金资本、国投高新、中信新未来等11家金融机构代表，中能融合、综合智慧能源科技公司2家应用单位代表、以及11家入驻企业代表见证揭牌仪式，并参加“大中小企业携手共进开新局”主题沙龙。中央研究院党委书记、董事长范霁红出席活动并致辞，副总经理沈峰主持活动。
          </p>
          <p style="text-indent: 20px">
            据介绍，国家电投清洁能源融通创新发展平台作为北京市“大中小企业融通发展平台”的三家试点单位之一，国家电投集团中央研究院已开放10000平方米空间载体以及科技资源、应用场景、软硬件配套等，向能源行业中小微企业和创业团队敞开怀抱。目前，已入驻企业近30家，其中两家已启动IPO计划，两家已入选2021年北京市“专精特新”中小企业。
            活动现场，除清洁捕获公司以外、北京兆瓦云数据科技公司、若普自动化技术（北京）有限公司、北京朗智科技有限公司等企业也入驻平台，“大手拉小手”，共同助力国家清洁能源事业发展。
          </p>
        </div>
        <div class="content" v-if="type == 5">
          <p style="text-indent: 20px">            
          </p>
          <p style="text-indent: 20px">            近日，「清洁捕获」完成险峰资本投资的数百万元，资金将用于早期团队建设。「清洁捕获」成立于2021年，主要的研发方向是将捕集而来的二氧化碳用于制造低碳混凝土材料，实现废弃二氧化碳的高效封存，以此来恢复地球的碳平衡。
          </p>
		  <p style="text-indent: 20px">            二氧化碳作为温室气体致使全球变暖，带来了生态环境破坏等一系列问题，二氧化碳减排已成为当今国际社会关注的热点。利用二氧化碳捕集、利用和封存（CCUS）技术可以直接把二氧化碳“捉住”，可以大幅减少二氧化碳的排放，再将二氧化碳资源化利用，可以实现变废为宝。
          </p>
		  <p style="text-indent: 20px">            目前，CCUS与可再生能源发电、生物质能、氢气，并称为全球公认的能源转型四大支柱。中国作为二氧化碳排放第一大国，CCUS同样将是我国实现碳中和目标的重要手段——据测算，2060年国内通过CCUS技术，将可实现二氧化碳利用与封存12-29亿吨。
          </p>
		  <p style="text-indent: 20px">            
		  而作为二氧化碳排放大户的建筑行业，已开始着手通过CCUS技术有效将二氧化碳捕集后加以利用，实现碳减排目标。
          </p>
		  <p style="text-indent: 20px">   众所周知，混凝土是人类有史以来使用量最大的建筑材料之一，其每年的消耗量已达到170亿吨。而水泥则是混凝土中最重要的原料之一，在生产过程中的碳排放量就已经占全球碳排放的7%，是工业排放中非常主要的一个排放源。
          </p>
		  <p style="text-indent: 20px">   国内在快速发展过程中有大量的基础设施建设投入，水泥用量已占到全球所有国家用量的总和，占到全球的60%以上。随着2022年4月住房和城乡建设部发布的国家标准《建筑节能与可再生能源利用通用规范》正式实施，如何高效降低建筑材料中的二氧化碳排放，已成为当下的重要议题。
          </p>
		  <p style="text-indent: 20px">   传统混凝土预制件制备的环节之一是“蒸汽养护”——将水泥、砂石骨料和水等原材料，在搅拌机中充分搅拌后，送入养护釜通过高温水蒸气使得混凝土硬化。而专注于CCUS技术研发应用的「清洁捕获」，其所开发的“二氧化碳矿化利用”技术体系，则主要将传统蒸汽养护的环节改进为矿化养护技术。
          </p>
		  <p style="text-indent: 20px">   具体来说，二氧化碳矿利用技术是将工业排放的二氧化碳，在混凝土生产中加入，并与其中的钙、镁等离子形成矿化反应转化为矿物。这一过程中不仅不需要燃煤产生高温环境，降低能耗的同时也可以形成碳的闭环使用。
          </p>
		  <p style="text-indent: 20px">   通过该项技术生产出新型低碳混凝土材料，不但能让混凝土建材的强度等指标有所提升，养护时间也比之前降低了一半以上，大大提升生产混凝土的效率。经过测算，通过“二氧化碳矿化利用”技术，可让混凝土全生命周期的碳足迹相较于传统的制作工艺能够减少80%，未来有机会做到负碳产品。
          </p>
		  <p style="text-indent: 20px">   「清洁捕获」创始人赵超表示，该项技术在混凝土工厂当中将捕集到的二氧化碳加入到反应釜中，在反应釜内用二氧化碳替代原先高温的蒸汽，矿化养护混凝土建材。
          </p>
		  <p style="text-indent: 20px">   该工艺在生产过程中，能够做到95%以上二氧化碳被有效利用。由于二氧化碳矿化反应在600℃以下的环境中不可逆，这样本来会进入大气的排放物永久地封存在混凝土中。
          </p>
		  <p style="text-indent: 20px">   据介绍，以20万方的混凝土预制建材工厂为例，二氧化碳矿化养护设备的改造成本只占了整体产线建造成本的5%左右。除了这部分一次性投入之外，在碳源与使用场景距离得当的状态下，使用二氧化碳做为原料养护混凝土，成本基本可以控制在200元/吨左右，生产成本基本与目前传统蒸汽养护法的成本持平，使得低碳混凝土终端价格没有“绿色溢价”，在行业内已经达到了可以商业推广的阶段。
          </p>
		  <p style="text-indent: 20px">   
		  不仅如此，二氧化碳矿化利用技术从长远来看还有更深的经济效益。
          </p>
		  <p style="text-indent: 20px">   
		  赵超表示，商品混凝土和混凝土预制产品，在未来通过二氧化碳矿化技术生产，本身不仅仅是建材产品，还是具备强大固碳效应的新型碳汇资源。
          </p>
		  <p style="text-indent: 20px">		  有数据显示，目前国内森林植被每年的固碳能力是9亿吨，而混凝土的固碳潜力在未来有望达到5-8亿吨，使用这项技术未来将通过碳交易开启一个近千亿元的固碳市场。而目前全国碳市场碳价还处于低位，未来还有很大的上升空间，使用这项技术的排放企业、混凝土厂商以及建筑商未来都是潜在的受益方。
          </p>
		  <p style="text-indent: 20px"> 		  作为国内最早开始二氧化碳矿化利用技术研发及商业化的团队，目前「清洁捕获」已经开始进行技术的市场化推广。据了解，公司此前与中建材等公司达成了战略合作协议，并将所生产的低碳混凝土建材未来在市场中进行应用。
          </p>
		  <p style="text-indent: 20px"> 		  在去年十月份，全球第一个万吨级工业规模二氧化碳养护混凝土示范工程当中，「清洁捕获」提供了技术支持。有数据显示，在这项课题当中，通过二氧化碳矿化养护技术可实现每年1万吨的二氧化碳温室气体封存，并生产1亿块MU15 标准的轻质实心混凝土砖。
          </p>
		  <p style="text-indent: 20px"> 		  
		  团队方面，「清洁捕获」技术源起于浙江大学能源清洁利用国家实验室，团队其他核心成员来自互联网、能源、水泥等行业。
          </p>          
        </div>
        <!--新闻6正文开始-->
		    <div class="content" v-if="type == 6">
          <p style="text-indent: 20px">            
          </p>
          <p style="text-indent: 20px">
            近日， 国内首个通过CCUS（二氧化碳捕集、利用与封存）生产的具有“吸碳”功能的混凝土建材，获得了权威检测机构颁发的碳足迹认证证书。该张碳足迹认证证书也标志着国内混凝土建材行业正式开始借助碳捕集利用技术实现减碳。根据测算，“清洁捕获固碳实心砖”与传统产品相比可减少87%的碳足迹。 
          </p>
          <img src="../static/news/p6/p61.png" class="msg-img" />
          <p style="text-indent: 20px">
            据了解，CTI华测检测作为此次碳足迹报告的认证机构， 该款固碳混凝土实心砖产品，严格按照《PAS 2050：2011商品和服务在生命周期内的温室气体排放评价规范》，从原始原料开始，依照混凝土建材产业链工艺流程，逐个分析产品在原材料获取、制造生产过程及运输、包装等阶段温室气体排放情况，计算出终端产品“从摇篮到大门”的碳足迹。
          </p>
          <p style="text-indent: 20px">
            此次获得碳足迹认证的实心砖是通过CCUS技术公司清捕零碳开发的将二氧化碳固定在混凝土中的“CLEANCARBON CO2 Mineralization”技术而生产的固碳产品。在混凝土材料中，“清洁捕获固碳混凝土”产品通过用工业副产品粉煤灰、高炉渣粉代替水泥以及矿化养护工艺替代高温蒸汽养护工艺，减少了108.12 kgCO2e /1000kg的二氧化碳，再通过使用定制注气设备和特殊的矿化助剂，成功吸收和固定了50.27 kgCO2e /1000kg的二氧化碳，总共减少了的158.39kgCO2e /1000kg的二氧化碳。该款产品最终的碳足迹为22.61 kgCO2e /1000kg，因此，与Ecoinvent 3.8数据库中使用传统工艺生产的普通实心砌块（181 kgCO2e /1000kg的二氧化碳排放量）相比，二氧化碳排放量减少了87%，接近实现零排放。
          </p>
          <p style="text-indent: 20px">
            据CTI华测检测介绍，在产品的生产阶段，评估小组参照权威计量监测机构提供的二氧化碳使用、吸收数据，核算出了二氧化碳矿化养护混凝土建材技术工艺将捕集的废弃二氧化碳充分利用封存所带来的减碳数值 “我们的评估小组此次也充分考量了前端排放企业在捕集二氧化碳过程中所带来的碳排放，并将其计算入该产品原料阶段产品的碳排放。此外，由于该产品借助CCUS技术实现了二氧化碳的封存利用，也是首次在报告中将封存利用的二氧化碳作为负值计算到整体的产品碳足迹中”。
          </p>
          <img src="../static/news/p6/p62.png" class="msg-img" />
          <p style="text-indent: 20px">
            据清捕零碳公司介绍，此次进行认证的“清洁捕获固碳实心砖”，是公司研发的固碳混凝土技术矩阵的第一代产品，也是公司迈向“一亿吨愿景”（通过CCUS技术利用混凝土固定与封存1亿吨二氧化碳）扎实的一步。目前该产品已在合作工厂中实现量产，将陆续在中国大陆及香港地区的商业项目进行大规模应用，帮助建筑企业在隐含碳方面减少大量碳排放。
          </p>
          <p style="text-indent: 20px">
            相信随着固碳混凝土建材不断在更多的项目得以应用， 未来CCUS技术也将成为建筑、建材行业重要的碳减排路径之一。
          </p>		 
        </div>
        <!--新闻6正文结束-->
        <!--新闻7正文开始-->
		    <div class="content" v-if="type == 7">
          <p style="text-indent: 20px">            
          </p>
          <p style="text-indent: 20px">
            1月16日，清捕零碳（北京）科技有限公司（以下简称清捕零碳）与中国建筑工程（香港）有限公司（以下简称中建香港）旗下公司正式签订合作协议。未来5年的时间里，双方将依托于清捕零碳研发的二氧化碳矿化混凝土建材技术，以及中建香港在港澳地区建筑行业的深耕经验，在港澳地区推广应用具有固碳属性的混凝土建材及技术，并以此为基础深化合作，探索建筑行业的绿色低碳发展新路径。            
          </p>
          <img src="../static/news/p7/p71.png" class="msg-img" />
          <p style="text-indent: 20px">
            清捕零碳作为是一家专注于CCUS技术研发与产业化的科技企业，经过多年的研发积累，已开发了二氧化碳捕集-矿化混凝土建材 “CLEANCARBON CO2 Mineralization”技术工艺，可将工业中捕集的废弃二氧化碳高效利用并封存于混凝土建材中，相较传统工艺在混凝土建材生产环节可减少80%以上的碳排放。清捕零碳联合创始人、CEO赵超表示，此次双方的合作，是公司迈向“一亿吨愿景”（利用CCUS技术通过混凝土固定与封存1亿吨二氧化碳）扎实的一步，目前公司研发的第一代固碳产品已实现量产，相信随着双方合作，未来在大湾区的建筑项目能更多看到固碳混凝土建材的身影，为建筑隐含碳的降低做出积极贡献。            
          </p>
          <p style="text-indent: 20px">
            在合作签约仪式上，中建香港物资部副总经理王琪表示，中建香港作为目前香港最大的建筑承建商和港澳地区深耕40余年的央企，在落实双碳政策方面始终积极响应国家号召，始终以推动香港建筑业绿色化发展为己任，希望此次合作双方可以发挥优势，积极推广固碳混凝土建材及技术，为港澳地区建筑绿色化发展提供可行方案。            
          </p>
          <img src="../static/news/p7/p72.png" class="msg-img" />
          <p style="text-indent: 20px">
            据了解，中建香港目前在建的有机资源回收中心二期项目是香港首个符合国际标准的自愿认证减排项目，建成后将成为香港最大规模的厨余回收中心，也是全国首个在施工期内实现碳中和的绿色示范工程。清捕零碳所提供的CCUS固碳混凝土建材曾在该项目中应用，经过测算，每使用1立方米的固碳混凝土产品与香港地区传统产品相比较可减少61公斤的二氧化碳排放，相当于1棵树三年的二氧化碳吸收量。              
          </p>
        </div>
        <!--新闻7正文结束-->
        <!--新闻8正文开始-->
		    <div class="content" v-if="type == 8">
          <p style="text-indent: 20px">            
          </p>
          <p style="text-indent: 20px">
            近日，长期关注全球可持续发展创新变革的Makeable 可持续创新观察和 Impact Hub Shanghai正式发布《2022 Impact 50 可持续创新先锋案例集》（以下简称《Impact 50》）。此次评选基于全球发展趋势，聚焦零碳转型、循环经济、可持续消费与供应链、包容性创新四大议题18个领域，清捕零碳凭借在CCUS领域的技术优势及商业化模式，从全球471个创新案例中脱颖而出，为通过CCUS技术实现全球大幅减排提供了变革性的创新方向。            
          </p>
          <img src="../static/news/p8/p81.png" class="msg-img" />
          <p style="text-indent: 20px">
            2022年是应对气候变化、保护生物多样性的关键之年，此次《Impact 50》涵盖四大议题：零碳转型、循环经济、可持续消费与供应链、包容性创新，并从中细分出清洁能源、废弃物处理、CCUS、绿色材料、乡村振兴等18个重点领域。报告中指出，CCUS技术是最直接的碳减排方式之一，而空气直接捕集二氧化碳（DAC）及二氧化碳转化利用被认为是CCUS未来的两大变革性技术创新方向。目前，二氧化碳资源化利用方式主要涉及生物利用、化工利用及矿化利用等方向。            
          </p>
          <img src="../static/news/p8/p82.png" class="msg-img" />
          <p style="text-indent: 20px">
            清捕零碳专注于二氧化碳矿化利用，依托“CLEANCARBON CO2 Mineralization”技术，对传统的混凝土建材生产养护工艺进行革新，可将捕集废弃的二氧化碳高效利用并封存于混凝土建材中。同时借助其自研的配方体系，已实现混凝土建材生产过程中大量使用工业固废，在产品原料端减少30%以上水泥用量的效果。            
          </p>
          <img src="../static/news/p8/p83.png" class="msg-img" />
          <p style="text-indent: 20px">
            清捕零碳所生产的固碳混凝土建材，与传统工艺生产的混凝土建材相比较可减少87%的二氧化碳排放量，接近实现零排放。目前，清捕零碳通过CCUS-CO2一体化模式体系及标准化的设备，将高排放企业、混凝土生产商、建筑公司进行有效链接，其固碳混凝土建材已开始在中国大陆及香港地区的商业项目中进行大规模应用，并帮助排放端、生产端、使用端的合作伙伴实现减排目标。            
          </p>
          <p style="text-indent: 20px">
            在此《Impact 50》评选中，来自美国的 LanzaTech 同样在CCUS领域入选，其利用气体发酵技术实现碳转化，可生产出可持续燃料、织物、包装等产品。LanzaTech今年3月宣布将通过 SPAC 的方式登陆纳斯达克，可能将成为 CCUS 产业中第一家上市的企业。            
          </p>
          <p style="text-indent: 20px">
            随着不同的CCUS技术方向在商业中广泛应用，新型商业的模式、多元化的产业格局将共同助推全球不同行业的碳减排发展。            
          </p>		 
        </div>
        <!--新闻8正文结束-->

        <!--新闻9正文开始-->
		    <div class="content" v-if="type == 9">
          <p style="text-indent: 20px">            
          </p>
          <p style="text-indent: 20px">
            5月10日，专注碳捕集利用与封存（以下简称〝CCUS〞）的技术企业清捕零碳与恒隆地产（“公司”或“恒隆”）宣布进行为期两年的战略合作（〝合作〞），双方将在二氧化碳矿化强化废弃混凝土低碳再生骨料（以下简称〝低碳RCA〞）技术研发及“清洁捕获固碳混凝土实心砖”（“固碳混凝土实心砖”）商业项目应用等层面开展深度合作，减少杭州恒隆广场和其他商业项目中的隐含碳排放。杭州恒隆广场将是内地和香港首个使用固碳混凝土实心砖的商业发展项目。            
          </p>
          <img src="../static/news/p9/p91.png" class="msg-img" />
          <p style="text-indent: 12px">
            恒隆地产与清捕零碳达成为期两年的战略合作，在杭州恒隆广场及其他恒隆项目中运用创新技术减少隐含碳排放。（左起）恒隆地产的代表包括：副董事—项目管理唐龙添先生、董事—项目管理劳建亮先生、副董事—可持续发展John Haffner先生；清捕零碳的代表包括：首席执行官赵超先生、浙江大学王涛教授及首席运营官刘金课先生            
          </p>
          <p style="text-indent: 20px">
            众所周知，与建筑物相关的隐含碳涵盖了建筑材料的开采、运输、建造、维护、更换、拆卸以至弃置过程中所产生的碳排放量，它占全球碳排放量的11％，并占建筑物典型的60年生命周期的碳排放量约75％。隐含碳排放量在建筑物中一旦建成便无法减少。            
          </p>
          <p style="text-indent: 20px">
            隐含碳是房地产公司范围3排放（即公司价值链中产生的间接排放）的主要来源。2022年，恒隆的范围3排放量约占其总排放量72％，其中建筑材料的隐含碳排放是最大的排放来源。恒隆正在积极应对减少隐含碳排放，并深悟与战略伙伴携手合作的重要性。
          </p>
          <p style="text-indent: 20px">
            恒隆地产副董事长兼可持续发展督导委员会主席陈文博先生表示：“要实现房地产脱碳，尤其是从隐含碳方面着手，是一场万里长征，而非一场短跑赛事。我们相信与清捕零碳和浙江大学合作，将可促进令人振奋的创新技术以推动这个旅程。同时，我们将继续与供应商密切合作，通过创新务实的解决方案减少碳排放。我们鼓励其他房地产公司一同加入，加速并扩大此类创新技术的应用。”
          </p>
          <p style="text-indent: 20px">
            清捕零碳首席执行官赵超先生表示：“混凝土是世界上用量最大的建筑材料，清捕零碳的CCUS技术不仅可以减少混凝土的碳排放，还能捕获到比它们在整个生命周期中排放还多的二氧化碳。各类商业地产等建筑作为一个大体积的人造物，也自然成为未来用来封存二氧化碳的理想场所。此次清捕零碳与恒隆地产的战略合作，既是清捕零碳迈向‘一亿吨愿景’坚实的一步，即利用CCUS技术固定与封存1亿吨二氧化碳，亦是双方将利用CCUS技术减少未来建筑物中的隐含碳，甚至变为碳汇资源的勇敢探索与尝试 “。
          </p>
          <p style="text-indent: 20px">
            此次合作将利用清捕零碳专有的二氧化碳矿化技术，通过两项举措在杭州恒隆广场推进CCUS应用：
          </p>
          <p style="text-indent: 20px">
            1、二氧化碳矿化强化废弃混凝土低碳RCA技术研发
          </p>
          <p style="text-indent: 20px">
            首先，双方将针对杭州恒隆广场发展项目所产生的废弃混凝土开展资源循环利用研究。研究人员将废弃混凝土破碎成骨料，并通过二氧化碳矿化强化工艺制成低碳RCA。经过全生命周期评估发现，与普通骨料相比，低碳RCA作为混凝土原料具有显著的减排潜力。恒隆和清捕零碳已经完成了一个低碳RCA的小规模试点项目，下一步计划针对150吨的废弃混凝土开展中试规模的生产验证。
          </p>
          <p style="text-indent: 20px">
            2、固碳混凝土实心砖商业项目应用
          </p>
          <p style="text-indent: 20px">
            其次，双方将在杭州恒隆广场的地下室的二次结构墙体中使用固碳混凝土实心砖（使用量可覆盖墙面面积约17,000平方米）。据了解，杭州恒隆广场是恒隆在内地第11座大型综合商业项目，涵盖一座世界级购物商场、五座甲级办公楼及奢华的杭州文华东方酒店。项目计划于2024年起分阶段落成。此次杭州恒隆广场项目应用固碳混凝土实心砖将成为内地及香港首个应用该技术的商业发展项目。在此项目中，清捕零碳通过用工业副产品粉煤灰、高炉渣粉代替水泥，并依托其专有的二氧化碳矿化养护工艺所打造的固碳混凝土实心砖，其隐含碳排放预期将较传统烧结砖低87.5％。
          </p>
          <img src="../static/news/p9/p92.png" class="msg-img" />
          <p style="text-indent: 20px">
            据了解，清捕零碳开发的技术源自浙江大学清洁能源利用国家重点实验室（CEU）。2020年，作为〝十三五〞五年规划期间的重点研发项目，浙江大学完成了〝二氧化碳深度矿化养护制建材关键技术及万吨级工业示范〞。同年，清捕零碳与CEU正式展开合作，共同承担了多个与CCUS技术相关的国家和地方研发项目。目前，双方共同打造的“CLEANCARBON CO2 Mineralization”技术体系，通过对混凝土建材原料配方、生产设备、工艺流程等环节的改造升级，可实现95%以上的工业中捕集的废弃二氧化碳被高效利用并封存于混凝土建材中。未来，随着该项技术在建筑项目中的广泛应用，将可助力整个建筑行业有效降低碳排放，实现绿色可持续的发展。
          </p>         		 
        </div>
        <!--新闻9正文结束-->
         <!--新闻10正文开始-->
		    <div class="content" v-if="type == 10">
          <p style="text-indent: 20px">            
          </p>
          <img src="../static/news/p10/p101.png" class="msg-img" />
          <p style="text-indent: 20px">
            36碳获悉，「清捕零碳」完成千万元天使+轮融资，由元禾原点、住友商事亚洲资本及其他产业方投资人出资。            
          </p>
          <p style="text-indent: 20px">
            「清捕零碳」创始人赵超告诉36碳，住友商事作为日本最大的混凝土交易商之一，未来将积极推进与住友商事在中国及海外地区的项目合作，本轮融资将用于持续落地二氧化碳矿化产线的建设规划及技术研发。            
          </p>
          <p style="text-indent: 20px">
            在全球气候持续变暖的当下，  二氧化碳的捕获、封存、再利用（CCUS技术），是一项最直接吸收二氧化碳的方式，也是碳中和道路的最后一公里。
          </p>
          <p style="text-indent: 20px">
            CCUS的技术最早来自于上世纪将二氧化碳用于驱油的利用，由于减排潜力大，还可以促进传统能源的清洁应用，目前已经从技术预研阶段逐渐走向了商业化初期部署阶段。
          </p>
          <p style="text-indent: 20px">
            《中国碳捕集利用与封存技术发展路线图（2019）》中显示，CCUS到2023年的产值规模将超过200亿/年，到2050年超过3300亿元/年，2025年-2050年的年均增长率达到11.9%。
          <p style="text-indent: 20px">
            目前，与建筑物相关的隐含碳排放量占据了全球排放量的11%，而其中建筑材料占比最大，约占整体60-70%以上。如何降低建筑隐含碳是双碳背景下建筑行业的主要诉求，因此，在CCUS技术的众多应用中，利用二氧化碳生产混凝土的矿化利用技术逐渐得到在建筑及基建领域规模化的应用。
          </p>
          <p style="text-indent: 20px">
            混凝土作为全球使用量最大的建筑材料，水泥是混凝土生产中的主要成分之一，其产生的二氧化碳排放量占全球CO2排放的7%以上。这是由于水泥生产过程中的化学反应以及制造所需的高温造成的。这也是混凝土作为一种碳密集型建筑材料的主要原因。
          </p>
          <p style="text-indent: 20px">
            赵超告诉36碳，「清捕零碳」将其所开发的“二氧化碳矿化利用”技术体系，在混凝土实心砖产品原料获取和生产阶段，以工业副产品粉煤灰、高炉渣粉代替水泥，并应用二氧化碳矿化养护工艺替代传统高温蒸汽养护工艺，每生产1000千克产品可避免产生108.12千克二氧化碳的排放。            
          </p>
          <img src="../static/news/p10/p102.png" class="msg-img" />
          <p style="text-indent: 20px">
            这套流程不仅仅是通过改善生产工艺来减少二氧化碳的排放，还真正固定了二氧化碳这一工业生产副产品。在二氧化碳封存和利用阶段，「清捕零碳」还应用了定制注气设备和特殊的矿化助剂，每生产1000千克产品可吸收固定50.27 千克二氧化碳。            
          </p>
          <p style="text-indent: 20px">
            据赵超介绍，通过该项技术所生产出的固碳混凝土材料，不但能让混凝土建材的强度等指标有所提升，养护时间也比之前降低了一半以上，大大提升生产混凝土的效率。
          </p>
          <p style="text-indent: 20px">
            不过，CCUS技术从实验室走向产业，最大的障碍是如何降低成本。赵超表示，从实验中试到产业化落地推广，公司通过在原材料体系、工艺改造、设备上做出的一系列调整，目前成本已经能够大致达到客户诉求，在一定条件下，能够做到与传统流程的生产成本一致。未来，在大规模应用之后，成本还会有进一步的下降空间。
          </p>
          <img src="../static/news/p10/p103.png" class="msg-img" />
          <p style="text-indent: 20px">
            2022年是「清捕零碳」商业化逐步跑通的一年。
          </p>
          <p style="text-indent: 20px">
            此前，恒隆地产宣布与「清捕零碳」围绕CCUS技术开展两年的合作，双方将在二氧化碳矿化强化废弃混凝土低碳再生骨料技术研发，以及“清洁捕获固碳混凝土实心砖”商业项目应用等层面开展合作，减少杭州恒隆广场和其他商业项目中的隐含碳排放。
          </p>
          <p style="text-indent: 20px">
            其中，杭州恒隆广场将是内地和香港首个使用固碳混凝土实心砖的商业发展项目。赵超表示，「清捕零碳」所生产的固碳实心砖碳足迹仅为22.61 kgCO2e/1000kg，与传统流程所生产的混凝土相比二氧化碳排放量减少了近87%。
          </p>
          <p style="text-indent: 20px">
            此外，「清捕零碳」在浙江湖州、陕西榆林、广东东莞、香港等地都有固碳混凝土相关实际应用案例。
          </p>
          <p style="text-indent: 20px">
            团队方面，「清捕零碳」所开发的技术源自浙江大学清洁能源利用国家重点实验室（CEU）。2020年，清捕零碳与CEU合作，共同承担了多个与CCUS技术相关的国家和地方研发项目，并建设了“浙江大学 — 清捕零碳二氧化碳矿化利用技术联合研发平台”，该平台为中国首个可实现大规模工业生产验证的二氧化碳矿化利用试验基地。
          </p>
          <p style="text-indent: 20px">
          </p>             		 
        </div>
        <!--新闻10正文结束-->
      </div>
    </div>
    
    <div style="width: 100%; margin-top: 251px">
      <footer-bar></footer-bar>
    </div>
  </div>
</template>

<script>
import topBar from "@/components/header-bar.vue";
import utils from "@/utils/common.js";
import footerBar from "@/components/footer-bar.vue";
export default {
  components: {
    topBar,
    footerBar,
  },
  data() {
    return {
      name: "Dynamic",
      menus: utils.menus,
      active: "Dynamic",
      swiperIndex: 1,
      type: null,
    };
  },
  created() {
    // console.log(this.$route.query)
    if (this.$route.query.type) {
      this.type = this.$route.query.type;
    }
  },
  computed: {
    logoImg() {
      // console.log(this.swiperIndex,'lll')
      if (this.swiperIndex == 0) {
        return require("../static/wlogo.png");
      } else if (this.swiperIndex == 1) {
        return require("../static/qlogo.png");
      } else if (this.swiperIndex == 2) {
        return require("../static/wlogo.png");
      } else if (this.swiperIndex == 3) {
        return require("../static/home/logo2.png");
      } else if (this.swiperIndex == 4) {
        return require("../static/home/logo2.png");
      } else if (this.swiperIndex == 5) {
        return require("../static/wlogo.png");
      } else if (this.swiperIndex == 6) {
        return require("../static/home/logo2.png");
      }
    },
    fontColor() {
      if (this.swiperIndex == 0) {
        return {
          color: "#fff",
        };
      } else if (this.swiperIndex == 1) {
        return {
          color: "#333",
        };
      } else if (this.swiperIndex == 2) {
        return {
          color: "#fff",
        };
      } else if (this.swiperIndex == 3) {
        return {
          color: "#333",
        };
      } else if (this.swiperIndex == 4) {
        return {
          color: "#333",
        };
      } else if (this.swiperIndex == 5) {
        return {
          color: "#fff",
        };
      } else if (this.swiperIndex == 6) {
        return {
          color: "#333",
        };
      }
    },
    dtBg() {
      if (this.swiperIndex == 0) {
        return {
          background: "#fff",
        };
      } else if (this.swiperIndex == 1) {
        return {
          background: "#333",
        };
      } else if (this.swiperIndex == 2) {
        return {
          background: "#fff",
        };
      } else if (this.swiperIndex == 3) {
        return {
          background: "#333",
        };
      } else if (this.swiperIndex == 4) {
        return {
          background: "#333",
        };
      } else if (this.swiperIndex == 5) {
        return {
          background: "#fff",
        };
      } else if (this.swiperIndex == 6) {
        return {
          background: "#333",
        };
      }
    },
  },
  methods: {
    changeOver(m) {
      // console.log(m)
      if (m.path == "solution") {
        m.hover = true;
        this.active = m.path;
      }
    },
    mouseLeave(m) {
      this.menus.forEach((item) => (item.hover = false));
      this.active = this.name;
    },
    changePath(item) {
      if (item.path != "solution") {
        this.$router.push({
          name: item.path,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.wrap {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  // background: #eeeeee;
  margin: 0;
  padding: 0;
}
.active-h {
  font-weight: 600;
}
.top-box {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  // background: #007AFF;
  .logo {
    width: 42px;
    height: 47px;
    margin-left: 11.25rem;
  }
  .menus-box {
    height: 100%;
    display: flex;
    align-items: center;
    margin-left: 510px;
    position: relative;
  }
  .menus {
    height: 100%;
    width: 114px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    // margin-right: 60px;
    font-size: 14px;
    font-weight: 400;

    cursor: pointer;
    box-sizing: border-box;
    position: relative;
    .dt-line {
      width: 20px;
      height: 4px;
      // background: #FFFFFF;
      position: absolute;
      bottom: 16px;
    }
    .se-me {
      position: absolute;
      width: 114px;
      height: 108px;
      bottom: -108px;
    }
    .child {
      width: 100%;
      height: 54px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      font-weight: 400;
      // color: #FFFFFF;
    }
  }
}

.header-tag {
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 400;
  color: #075ad3;
  margin-top: 130px;
  margin-left: 175px;
}
.body-box {
  width: 100%;
  display: flex;
  align-items: flex-start;
  // justify-content: space-between;
  padding: 0 0 0 175px;
  box-sizing: border-box;
  margin-top: 50px;
  .left-box {
    width: 299px;
    height: 357px;
    background: #fafbff;
    padding: 24px 24px 0 24px;
    box-sizing: border-box;
    position: relative;
    margin-right: 60px;
    .tag-title {
      font-size: 20px;
      font-weight: 500;
      color: #1a1a1a;
      margin-bottom: 10px;
    }
    .new-box {
      width: 100%;
      min-height: 64px;
      // sbackground: red;

      font-size: 18px;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      font-weight: 400;
      color: #1a1a1a;
    }
    .new-border {
      border-bottom: 1px solid #e6e6e6;
    }
    .dot {
      width: 18px;
      height: 18px;
      background: linear-gradient(
        320deg,
        rgba(103, 165, 255, 0) 0%,
        #77aeff 100%
      );
      position: absolute;
      border-radius: 50%;
      top: 20px;
      left: 16px;
    }
  }
  .right-box {
    width: 780px;
    // padding-left: 60px;
    box-sizing: border-box;
    .ri-title {
      font-size: 28px;
      font-weight: 500;
      color: #1a1a1a;
      margin-bottom: 32px;
    }
    .content {
      font-size: 16px;
      font-weight: 400;
      color: #666666;
      text-indent: 30px;
      margin-bottom: 24px;
    }
    .msg-img {
      width: 750px;
      height: 100%;
      margin-top: 12px;
      margin-left: 10px;
    }
    .book-title-small {
      font-size: 18px;
      font-weight: 500;
      color: #1a1a1a;
      text-align: left;
      margin-bottom: 12px !important;
    }
  }
}
</style>
